import Link from 'next/link';
import Cartcount  from  "./cartcount";

import {WEBSERVER} from "../services/globals";
import MenuComponent from './menu';
import {Collection, CategoriesData } from "./contracts/types";
import User from './user';



const Header2 = ({collections}) => {
//    console.log('Header2:' + JSON.stringify(collections));
  return (
    <div className="header-top d-flex flex-row justify-content-center">
      <ul className="horizontal">
        <li><MenuComponent collections={collections}></MenuComponent></li>
        <li className="d-flex bigfont"><Link className="bigfont" href="/cart"><i className="bi-cart-fill fs-2" title="Warenkorb"></i><Cartcount></Cartcount></Link></li>
        <li><User></User></li>
      </ul>
  </div>
  );
};

export default Header2;
